import React from 'react'
import PropTypes from 'prop-types'

const Success = ({ address, totalPoints, initialMiles, transactionId }) => {
  return (
    <div className='border-color-ui-3 border-top'>
      <div className='d-flex border-color-ui-3 border-bottom'>
        <div className='col-md-2 col-3'>
          <div className='border-color-ui-3 border mt-2 p-3' />
        </div>
        <div className='col-md-10 col-9 p-2'>
          <div className='border-color-ui-3 border-bottom pb-2'>
            <p>
              <strong>Sua solicitação gerou o número:</strong>
            </p>
            <h3 className='color-brand-1'>#{transactionId}</h3>
          </div>
          <div className='d-flex flex-column flex-md-row mt-2'>
            <div className='col-md-6 col-12 p-0 pr-2'>
              <p className='mb-2'><strong>Endereço de entrega</strong></p>
              <p>{address.street}, {address.number} - {address.complement}</p>
              <p>{address.city} - {address.state}</p>
              <p>CEP: {address.zipCode}</p>
            </div>
            <div className='col-md-6 col-12 p-0 mt-3 mt-md-0'>
              <p className='mb-2'><strong>Crédito inicial</strong></p>
              <p>Pontos utilizados: {totalPoints} pontos</p>
              <p><strong className='color-brand-1'>Valor creditado: R$ {initialMiles}</strong></p>
            </div>
          </div>
        </div>
      </div>
      <div className='p-3' />
    </div>
  )
}

Success.propTypes = {
  address: PropTypes.object,
  totalPoints: PropTypes.any,
  initialMiles: PropTypes.any,
  transactionId: PropTypes.string
}

export default Success



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Success/Success.js